import React from 'react';
import TodaysCompletedOrders from '../components/Orders/TodaysCompletedOrders';

const CounterPage = () => {
  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <div className="max-w-5xl mx-auto bg-white rounded-lg shadow-md p-6">
        <h1 className="text-2xl font-semibold mb-4 text-gray-800">Counter View - Completed Orders</h1>
        <TodaysCompletedOrders />
      </div>
    </div>
  );
};

export default CounterPage;
